/** Janela mínima carregada do backend, mesmo quando o preset filtra menos. */
export const DAYS_WINDOW_DEFAULT = 90;

/** Janela máxima absoluta (limite do backend). */
export const DAYS_WINDOW_MAX = 365;

/** Opções rápidas pro chip do Toolbar. */
export const PERIOD_OPTS = [
    { id: 'today', label: 'Hoje' },
    { id: '7d', label: 'Últimos 7 dias' },
    { id: '30d', label: 'Últimos 30 dias' },
    { id: 'month', label: 'Mês atual' },
    { id: 'quarter', label: 'Trimestre' },
    { id: 'custom', label: 'Personalizado...' },
];
